import apiUtils from '@elab/core/utils/apiUtils';
import HTTPClient from '@elab/core/utils/HTTPClient';
import { serverErrors } from '@elab/core/utils/constants';

const endpointName = 'wishlist';
const endpoint = () => `${apiUtils.getBaseUri()}/${endpointName}`;

const loadWishlist = async filterName => {
    const uri = `${endpoint()}?fields=FULL&sort=${filterName}`;
    const response = await HTTPClient().get(uri);

    if (!response.ok) {
        throw new Error(`Unable to load wishlist (${response.status})`);
    }
    return await response.json();
};

const loadNewWishlist = async filterName => {
    const uri = `${endpoint()}?fields=LIGHT&sort=${filterName}`;
    const response = await HTTPClient().get(uri);

    if (!response.ok) {
        throw new Error(`Unable to load wishlist (${response.status})`);
    }
    return await response.json();
};

const createWishlist = async wishlistName => {
    const uri = `${endpoint()}?fields=DEFAULT&wishlistName=${wishlistName}`;
    const response = await HTTPClient().postJson(uri);

    if (!response.ok) {
        throw new Error(`Unable to create wishlist (${response.status})`);
    }
    return await response.json();
};

const addToWishlist = async (wishlistCode, productCode) => {
    const uri = `${endpoint()}/${wishlistCode}/entries/${productCode}`;
    const response = await HTTPClient().postJson(uri);

    if (!response.ok) {
        throw new Error(`Unable to add to wishlist (${response.status})`);
    }
};

const updateWishList = async (wishlistCode, productCode, quantity) => {
    const uri = `${endpoint()}/${wishlistCode}/entries/${productCode}/${quantity}`;
    const response = await HTTPClient().patchJson(uri);

    if (!response.ok) {
        throw new Error(`Unable to update to wishlist(${response.status})`);
    }
};

const addEgiftCardToWishlist = async (wishlistCode, productData) => {
    const uriwithoutCard = `${endpoint()}/${wishlistCode}/egiftcard`;
    const response = await HTTPClient().postJson(uriwithoutCard, productData);
    const responseJSON = await response.json();
    const errType = responseJSON.errors && responseJSON.errors[0] && responseJSON.errors[0].type;
    if (errType === serverErrors.IllegalStateError) {
        throw new Error(serverErrors.IllegalStateError);
    }
    if (!response.ok) {
        throw new Error(`Unable to add to wishlist (${response.status})`);
    }
};

const addToCart = async (wishlistCode, cartId, productCode, quantity) => {
    const uri = `${endpoint()}/${wishlistCode}/${cartId}/entries/${productCode}/${quantity}`;
    const response = await HTTPClient().postJson(uri);

    if (!response.ok) {
        throw new Error(`Unable to add product ${productCode} to cart (${response.status})`);
    }

    return await response.json();
};

const addAllProductsToCart = async (wishlistCode, cartId, sharedWishlistToken = '') => {
    let uri = '';
    if (sharedWishlistToken) {
        uri = `${endpoint()}/${wishlistCode}/${cartId}/entries?token=${sharedWishlistToken}`;
    } else {
        uri = `${endpoint()}/${wishlistCode}/${cartId}/entries`;
    }
    const response = await HTTPClient().postJson(uri);

    if (!response.ok) {
        throw new Error(`Unable to add products to cart (${response.status})`);
    }

    return await response.json();
};

const removeFromWishlist = async (wishlistCode, productCode) => {
    const uri = `${endpoint()}/${wishlistCode}/entries/${productCode}`;
    const response = await HTTPClient().delete(uri);

    if (!response.ok) {
        throw new Error(`Unable to remove from wishlist (${response.status})`);
    }
};

const loadSelectedWishlist = async (wishlistCode, token = '') => {
    let uri = '';
    let response = {};
    if (token) {
        uri = `${endpoint()}/${wishlistCode}?token=${token}`;
        response = await fetch(uri);
    } else {
        uri = `${endpoint()}/${wishlistCode}?fields=FULL`;
        response = await HTTPClient().get(uri);
        if (!response.ok) {
            throw new Error(`Unable to load wishlist ${wishlistCode} (${response.status})`);
        }
    }
    return await response.json();
};

const shareWishlist = async (wishlistCode, email) => {
    const uri = `${endpoint()}/${wishlistCode}/share`;
    const response = await HTTPClient().postJson(uri, { email });

    if (!response.ok) {
        throw new Error('Unable to share wishlist');
    }
};

const removeWishlist = async wishlistCode => {
    const uri = `${endpoint()}/${wishlistCode}`;
    const response = await HTTPClient().delete(uri);
    if (!response.ok) {
        throw new Error(`Unable to remove wishlist (${response.status})`);
    }
};

const renameWishlist = async (wishlistCode, name) => {
    const uri = `${endpoint()}/${wishlistCode}`;
    const response = await HTTPClient().patchJson(uri, {
        name,
    });
    if (!response.ok) {
        throw new Error(`Unable to rename wishlist (${response.status})`);
    }
};

const addEGiftCardToCart = async (wishlistCode, cartId, dto) => {
    const uri = `${endpoint()}/${wishlistCode}/${cartId}/egiftcards`;
    const response = await HTTPClient().postJson(uri, dto);

    if (!response.ok) {
        throw {
            json: await response.json(),
            status: response.status,
        };
    }

    return await response.json();
};

export default {
    loadWishlist,
    createWishlist,
    addToWishlist,
    updateWishList,
    addToCart,
    addAllProductsToCart,
    removeFromWishlist,
    loadSelectedWishlist,
    shareWishlist,
    removeWishlist,
    renameWishlist,
    addEgiftCardToWishlist,
    addEGiftCardToCart,
    loadNewWishlist,
};
